import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { DataServiceService } from "../data-service.service";

@Component({
  selector: "app-all-companies",
  templateUrl: "./all-companies.component.html",
  styleUrls: ["./all-companies.component.scss"],
})
export class AllCompaniesComponent implements OnInit {
  searchTerm = "";
  allCompanies = [];
  isLoading: boolean = true;
  constructor(
    private router: Router,
    private dataService: DataServiceService
  ) {}

  ngOnInit(): void {
    this.getAllCompanies().then(() => {
      this.isLoading = false;
    });
  }

  addNewCompany() {
    this.router.navigate(["/new-company"]);
  }

  viewCompanyDetails(companyId) {
    this.router.navigate(["/view-company", companyId]);
  }

  async getAllCompanies() {
    this.allCompanies = await this.dataService.getAllCompanies();
  }
}
